export const PRESET_FILTERS = {
  ASSIGNED_TO: 'assignedTo',
  REPORTED_BY: 'reportedBy',
} as const;

export type PresetFilter = (typeof PRESET_FILTERS)[keyof typeof PRESET_FILTERS];
